import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mh8t7w72tx: FaireBrandEntity = {
  token: "b_mh8t7w72tx",
  type: "brand",
  name: "Cedar Hill Homestead",
  avatarUrl:
    "https://cdn.faire.com/fastly/384f13a2ed2edddf0512f246d3ee72a3cd330606d50598dd77a5ab6096179ca8.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/aa787d2c7db87acc463f7ca7df009754b9909c31960dd8f7c76764bce22069e4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/384f13a2ed2edddf0512f246d3ee72a3cd330606d50598dd77a5ab6096179ca8.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/aa787d2c7db87acc463f7ca7df009754b9909c31960dd8f7c76764bce22069e4.jpeg",
  location: "Springfield, TN, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 13,
  isTopShop: true,
  isInsider: true,
  description:
    "Appalachian animist. Land & people steward. Home to seasonal, bioregional remedies from natural haircare & skincare to tinctures & teas. Sharing ancestral herbal knowledge, homestead tips & reconnecting with the cycles of nature.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:16.698Z",
    importedBy: "entity-db-cli",
  },
};
